module.exports = __webpack_public_path__ + "img/checklist-button-chest.72722c64.png";